import React, { useState, useEffect } from 'react';
import { homologatorStatus } from '../services/query';
import { roles } from '../services/user';

const DEFAULT_VALUE = { 
  exists: false,
  requireImages: false,
  homologatorId: null,
  reregistrationBlock: false,
  hasIntegratedQuery: false,
  daysBlockSendRequery: false,
  compelConsentForm: false,
  hasCertificateManagement: false,
  error: {} 
};

const { Provider, Consumer } = React.createContext(DEFAULT_VALUE);

export function HomologatorProvider(props) {
  const [value, setValue] = useState(DEFAULT_VALUE);

  useEffect(() => {
    const hasCertificateManagement = roles('profile.certificate');
    homologatorStatus()
      .then(({ status, 
        data: { 
          requireImages,
          homologatorId,
          reregistrationBlock,
          hasIntegratedQuery,
          daysBlockSendRequery,
          compelConsentForm
        } }) => {
        if (status === 404)
          return setValue({ 
            requireImages: false,
            exists: false,
            homologatorId, 
            reregistrationBlock,
            hasIntegratedQuery,
            daysBlockSendRequery,
            compelConsentForm,
            hasCertificateManagement
          });

        return setValue({
          exists: true,
          requireImages,
          homologatorId,
          reregistrationBlock,
          hasIntegratedQuery,
          daysBlockSendRequery,
          compelConsentForm,
          hasCertificateManagement
        });
      }).catch(({response}) => setValue({ requireImages: false, exists: false, homlogatorId: null,
        hasCertificateManagement: false,
        error: { 
          message: response.data.message, 
          status: response.status, statusText: 
          response.statusText }}));
  }, value);

  return <Provider value={value} {...props} />;
}

export const HomologatorConsumer = Consumer;
